import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '@fiverr-private/i18n-react';
import { HEADER_NAV_SOURCE } from '../../../../constants';
import Link from '../../../Links/Link';

export const SellerReferralsLink = () => {
    const link = pathfinder('render_seller_referrals_dashboard_page', {}, { query: { source: HEADER_NAV_SOURCE } });

    return (
        <Link href={link} rel="noopener noreferrer" className="nav-link" isNew>
            {translate('header.seller_referrals')}
        </Link>
    );
};
